export interface IDepartmentResponse {
  id: string;
  name: string;
  icon: IImage;
  banner: IImage;
  createdAt: Date;
  updatedAt: Date;
}

import { IImageSize } from './i-image-size';

export interface IImage {
  id: string;
  url: string;
  sizes: IImageSize[];
}
